module.exports = __webpack_public_path__ + "static/test2-aeeb0db9f9883fedd89f1c562232354e.jpg";